import { FigureDrawAction } from './figure-draw-action';
import { DrawAction, DrawActionElement, DrawOptions } from '../draw-action';

declare const fabric;

export class LineDrawAction extends FigureDrawAction {

    drawActionElement: DrawActionElement = DrawActionElement.LINE;

    createCanvasElement(options?: DrawOptions): any {

        let left = 10;
        let top = 10;
        let color = 'red';
        let borderWidth = 10;

        if (options) {

            if (options.stampingPosition) {
                left = options.stampingPosition.x;
                top = options.stampingPosition.y;
            }

            if (options.color) {
                color = options.color.getColorString();
            }

            if (options.borderWidth) {
                borderWidth = options.borderWidth;
            }
        }

        let cornerSize = DrawAction.defaults.cornerSize;

        if (this.isTouchDevice()) {
            cornerSize *= 2;
        }

        return new fabric.Line([0, 0, 100, 0], {
            stroke: color,
            strokeWidth: borderWidth,
            left,
            top,
            borderColor: DrawAction.defaults.borderColor,
            cornerColor: DrawAction.defaults.cornerColor,
            cornerSize,
            transparentCorners: DrawAction.defaults.transparentCorners
        });
    }
}
